import { CheckoutActionTypes } from '../../../enums/ActionEnums';
const checkoutActions = {
    createInitAction(payload) {
        return {
            type: CheckoutActionTypes.INIT,
            payload,
        };
    },
    createInitSetAction(payload) {
        return {
            type: CheckoutActionTypes.INIT_SET,
            payload,
        };
    },
    createErrorAction() {
        return {
            type: CheckoutActionTypes.ERROR,
        };
    },
    createLoginAnalyticsAction() {
        return {
            type: CheckoutActionTypes.LOGIN_ANALYTICS,
        };
    },
    createAnalyticsSuccessAction(payload) {
        return {
            type: CheckoutActionTypes.ANALYTICS_SUCCESS,
            payload,
        };
    },
    createAnalyticsConfirmationPageAction() {
        return {
            type: CheckoutActionTypes.ANALYTICS_CONFIRMATION_PAGE_STEP,
        };
    },
    createAnalyticsMergeConfirmationPageAction(payload) {
        return {
            type: CheckoutActionTypes.ANALYTICS_MERGE_CONFIRMATION_PAGE,
            payload,
        };
    },
    createGetConfirmationOrderAction() {
        return {
            type: CheckoutActionTypes.GET_CONFIRMATION_ORDER,
        };
    },
    createSetConfirmationOrderAction(payload) {
        return {
            type: CheckoutActionTypes.SET_CONFIRMATION_ORDER,
            payload,
        };
    },
    createSetConfirmationIsCollectStoreAction(payload) {
        return {
            type: CheckoutActionTypes.SET_CONFIRMATION_IS_COLLECT_STORE,
            payload,
        };
    },
    createSetConfirmationOrderErrorAction(payload) {
        return {
            type: CheckoutActionTypes.SET_CONFIRMATION_ORDER_ERROR,
            payload,
        };
    },
    createSetNewsletterPreferencesAction(payload) {
        return {
            type: CheckoutActionTypes.SET_NEWSLETTER_PREFERENCES,
            payload,
        };
    },
    createSetHasRegistrationAction(hasRegistration) {
        return {
            type: CheckoutActionTypes.SET_HAS_REGISTRATION,
            payload: hasRegistration,
        };
    },
};
export default checkoutActions;
